import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { hollowPie } from '@/views/echarts/pie/components';
import { proportionBar, groupBar } from '@/views/echarts/bar/components';
import { moreLine } from '@/views/echarts/line/components';
import { cardList, mutiCard, shopRank } from '@/views/index/components';
import { rankData } from './utils';
import { seriesMap } from '@/views/echarts/map/components';
export default {
  components: {
    proportionBar,
    groupBar,
    moreLine,
    cardList,
    mutiCard,
    shopRank,
    hollowPie,
    seriesMap
  },
  props: {
    itemObj: {
      type: Object,
      default() {
        return {};
      }
    },
    itemNum: {
      type: Number,
      default: -1
    }
  },
  watch: {
    itemObj: {
      handler(nl, ol) {
        if (this.itemObj.showForm == 'TOP_LIST') {
          this.rankData = [];
          this.itemObj.panelData.map(item => {
            this.rankData.push({
              value: item.sourceNum,
              area: item.sourcesName
            });
          });
        }
      }
    },
    deep: true
  },
  data() {
    return {
      rankData: []
    };
  },
  mounted() {
    this.$nextTick(() => {
      if (this.itemObj.showForm == 'TOP_LIST') {
        if (this.itemObj.panelData) {
          this.rankData = [];
          this.itemObj.panelData.map(item => {
            this.rankData.push({
              value: item.sourceNum,
              area: item.sourcesName,
              show: false
            });
          });
        } else {
          this.rankData = rankData();
        }
      }
    });
  }
};